import axios from 'axios';

// Support for both Vite and Create React App environments
const BASE_URL = import.meta.env?.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;

const projectService = {
  
  // 1. LIST (POST)
  getAllProjects: async () => {
    try {
      const response = await axios.post(`${BASE_URL}/projects/list`);
      
      // Backend returns: { success: true, data: [...] }
      if (response.data && response.data.success) {
        return response.data.data; 
      }
      
      return [];
    } catch (error) {
      console.error("Fetch Error:", error);
      throw error.response?.data || "Could not fetch projects";
    }
  },

  // 2. CREATE (POST) - Now using JSON
  addProject: async (projectData) => {
    try {
      // We send projectData as a plain object, Axios defaults to application/json
      const response = await axios.post(`${BASE_URL}/projects/create`, projectData);
      return response.data;
    } catch (error) {
      console.error("Add Project Error:", error);
      throw error.response?.data || "Error adding project";
    }
  },

  // 3. UPDATE (POST) - Now using JSON
  updateProject: async (id, projectData) => {
    try {
      const response = await axios.post(`${BASE_URL}/projects/update`, { id , ...projectData});
      return response.data;
    } catch (error) {
      console.error("Update Project Error:", error);
      throw error.response?.data || "Error updating project";
    }
  },

  // 4. DELETE (POST)
  deleteProject: async (id) => {
    try {
      const response = await axios.post(`${BASE_URL}/projects/delete`, { id, isDeleted: true });
      return response.data;
    } catch (error) {
      console.error("Delete Project Error:", error);
      throw error.response?.data || "Error deleting project";
    }
  }
};

export default projectService;